import React from 'react';
import { styled } from 'linaria/react';
import { useContext } from 'react';
import SiteContentContext from '../../SiteContent/SiteContentContext';
import NewsletterField from '../../Newsletter/NewsletterField';
import MaxWidth from '../../Layout/MaxWidth';
import { theme } from '../../Theming/Theming';

const NewsletterBoxWrapper = styled('div')`
  padding: 5rem 0;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #fff;
  .newsletter-wrapper {
    max-width: 1000px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    gap: 2rem;
    ${theme.below.md} {
      flex-direction: column;
    }
    .newsletter-fields-wrapper {
      flex-grow: 1;
      ${theme.below.md} {
        width: 100%;
      }
    }
    .content-wrapper {
      ${theme.below.md} {
        width: 100%;
        text-align: center;
      }
    }
  }
`;

const NewsletterBox = () => {
  const { Newsletter: item } = useContext(SiteContentContext);
  if (!item || !item.show) return null;
  return (
    <NewsletterBoxWrapper>
      <MaxWidth>
        <div className="newsletter-wrapper">
          <div className="content-wrapper">{item.html}</div>
          <NewsletterField />
        </div>
      </MaxWidth>
    </NewsletterBoxWrapper>
  );
};

export default NewsletterBox;
